import React, { Component } from 'react';
import Slider from "react-slick";
import {
  isMobile
} from "react-device-detect";

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className + ' icon-circle-right'}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className + ' icon-circle-left'}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    />
  );
}


class SliderBrandContent extends Component {

  constructor(props){
    super(props)
    this.state = {
      slider: [],
      activeIndex: 1,
      left: 0
    }
  }

  componentDidMount(){
    this.setState({ 
      slider: this.props.content
    })
  }

  componentWillReceiveProps(next_props) {
    if(next_props.content !== this.state.slider){
      this.setState({ 
        slider: next_props.content
      })
    }
  }


  render() {
    const numbersel = this.state.slider.length > 0 && this.state.slider.length < 4? this.state.slider.length : 4;
    const settings = {
        dots: false,
        infinite: true,
        slidesToShow: numbersel,
        slidesToScroll: 2,
        className: 'icon-circle-left',
        classNamer: 'icon-circle-right',
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        autoplay: true,
        speed: 2000,
        autoplaySpeed: 4000,
      }
    const settingsMobile = {
        dots: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 2,
        className: 'icon-circle-left',
        classNamer: 'icon-circle-right',
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        autoplay: true,
        speed: 2000,
        autoplaySpeed: 4000,
      }
      
    if (isMobile) {
      return (
        <div className="container-sl">
          {
            this.state.slider != null && this.state.slider.length > 0 && 
              <Slider {...settingsMobile}>
                {
                  this.state.slider.map((item, i) => { 
                    let large = (item.imgft_field && item.imgft_field.length > 0)?item.imgft_field:''
                    let medium = (item.imgmb_field && item.imgmb_field.length > 0)?item.imgmb_field:''
                    let small = (item.imgms_field && item.imgms_field.length > 0)?item.imgms_field:''
                    return (
                      <picture key={i}>
                        <source srcSet={small} media="(max-width: 425px)" />
                        <source srcSet={medium} media="(max-width: 768px)" />
                        <img src={large} alt={item.title.rendered} key={i}/>
                      </picture>
                    )
                  })
                }
              </Slider>
          }
        </div>
      )
    }else{
      return (
        <div className="container-sl">
          {
            this.state.slider != null && this.state.slider.length > 0 && 
              <Slider {...settings}>
                {
                this.state.slider.map((item, i) => {
                  let large = (item.imgft_field && item.imgft_field.length > 0)?item.imgft_field:''
                  let medium = (item.imgmb_field && item.imgmb_field.length > 0)?item.imgmb_field:''
                  let small = (item.imgms_field && item.imgms_field.length > 0)?item.imgms_field:'' 
                  return (
                    <picture key={i}>
                      <source srcSet={small} media="(max-width: 425px)" />
                      <source srcSet={medium} media="(max-width: 768px)" />
                      <img src={large} alt={item.title.rendered} />
                    </picture>
                  )
                })
              }
              </Slider>
          }
        </div>
      )
    }
  }
}

export default SliderBrandContent



// WEBPACK FOOTER //
// ./src/SliderBrand.js